import { MinimalEntity } from "BaseEntity"
import { PartSerialStatusDTO } from "models"

export class PlantDTOInner extends MinimalEntity {
	duns: int
	partSerialStatuses: PartSerialStatusDTO[]
	totalCount: int
	/** From containment-service PlantData.flexnetVersion (trace.PLANT.FLEXNET_VERSION). */
	flexnetVersion?: string | null
}

export interface PlantDTO {
	plants?: PlantDTOInner[]
}
